module.exports = __webpack_public_path__ + "img/app-prev-ua.97f7e105.png";